import Vue from 'vue'
import VueLodash from 'vue-lodash'
import { each, map, isEmpty, find, cloneDeep } from 'lodash'

Vue.use(VueLodash, { lodash: { each, map, isEmpty, find, cloneDeep } });